/* GoGoFable — scroll reveal + carousels (vanilla, no deps) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.gf-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCarousels() {
    document.querySelectorAll('[data-gf-carousel]').forEach(function (root) {
      var track = root.querySelector('.gf-carousel__track');
      var prev = root.querySelector('[data-gf-prev]');
      var next = root.querySelector('[data-gf-next]');
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initStickyCta() {
    var bar = document.querySelector('[data-gf-stickycta]');
    if (!bar) return;
    function update() {
      var y = window.scrollY || window.pageYOffset || 0;
      var past = y > window.innerHeight * 0.7;
      var nearBottom = (window.innerHeight + y) > (document.body.scrollHeight - 720);
      bar.classList.toggle('is-visible', past && !nearBottom);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() { initReveal(); initCarousels(); initStickyCta(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when sections are added/edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  'use strict';

  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var LORA = 'https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&display=swap';

  var reader = null, book = null, views = [], index = 0, opener = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  // The book's typeface — only fetched once a reader is actually opened, so it
  // never sits on the storefront's critical path.
  function ensureLora() {
    if (document.getElementById('gf-lora')) return;
    var l = document.createElement('link');
    l.id = 'gf-lora'; l.rel = 'stylesheet'; l.href = LORA;
    document.head.appendChild(l);
  }

  function isPhone() { return window.matchMedia('(max-width: 760px)').matches; }

  function build() {
    if (reader) return reader;
    reader = el('div', 'gf gf-reader');
    reader.setAttribute('role', 'dialog');
    reader.setAttribute('aria-modal', 'true');
    reader.hidden = true;
    reader.innerHTML =
      '<div class="gf-reader__progress" data-progress style="width:0"></div>' +
      '<div class="gf-reader__top">' +
        '<div class="gf-reader__id">' +
          '<div class="gf-reader__title" data-title></div>' +
          '<div class="gf-reader__brief" data-brief></div>' +
        '</div>' +
        '<button class="gf-reader__close" data-close aria-label="Close">' + CLOSE + '</button>' +
      '</div>' +
      '<div class="gf-reader__stage" data-stage></div>' +
      '<div class="gf-reader__bottom">' +
        '<div class="gf-reader__nav">' +
          '<button class="gf-reader__btn" data-prev aria-label="Previous page">' + ARROW + '</button>' +
          '<span class="gf-reader__count" data-count></span>' +
          '<button class="gf-reader__btn" data-next aria-label="Next page" style="transform:scaleX(-1)">' + ARROW + '</button>' +
        '</div>' +
        '<div class="gf-reader__cta"><a class="gf-btn gf-btn--primary" data-cta href="#">Create their story</a></div>' +
      '</div>';
    document.body.appendChild(reader);

    reader.querySelector('[data-close]').addEventListener('click', close);
    reader.querySelector('[data-prev]').addEventListener('click', function () { go(index - 1); });
    reader.querySelector('[data-next]').addEventListener('click', function () { go(index + 1); });

    var sx = 0, sy = 0;
    reader.addEventListener('touchstart', function (e) {
      sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY;
    }, { passive: true });
    reader.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (reader.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(index + 1);
      else if (e.key === 'ArrowLeft') go(index - 1);
    });

    // Re-group between spreads and single pages when the breakpoint is crossed,
    // holding the reader on the page the person was already looking at.
    var wasPhone = isPhone();
    window.addEventListener('resize', function () {
      if (reader.hidden || isPhone() === wasPhone) return;
      wasPhone = isPhone();
      var anchor = firstPageOf(index);
      views = makeViews(book);
      index = viewContaining(anchor);
      render();
    });

    return reader;
  }

  // Title page, then the book's own pages, then the closing card. On a phone
  // each page stands alone; otherwise they pair into openings exactly as bound —
  // doubles fall as left|right, and consecutive singles face each other.
  function makeViews(b) {
    var out = [{ type: 'title' }];
    var pages = b.pages || [];
    if (isPhone()) {
      pages.forEach(function (p) { out.push({ type: 'pages', pages: [p] }); });
    } else {
      for (var i = 0; i < pages.length; i += 2) {
        out.push({ type: 'pages', pages: pages.slice(i, i + 2) });
      }
    }
    out.push({ type: 'end' });
    return out;
  }

  function firstPageOf(i) {
    var v = views[i];
    return v && v.type === 'pages' ? v.pages[0].page : (i === 0 ? 0 : Infinity);
  }
  function viewContaining(pageNo) {
    if (pageNo === 0) return 0;
    if (pageNo === Infinity) return views.length - 1;
    for (var i = 0; i < views.length; i++) {
      var v = views[i];
      if (v.type === 'pages' && v.pages.some(function (p) { return p.page === pageNo; })) return i;
    }
    return 0;
  }

  function buildPage(p) {
    var page = el('div', 'gf-page gf-page--' + p.half);
    var img = new Image();
    img.className = 'gf-page__img';
    img.src = p.src;
    img.alt = '';
    img.decoding = 'async';
    page.appendChild(img);
    page.appendChild(el('div', 'gf-page__fade'));

    if (p.text) {
      var wrap = el('div', 'gf-page__text');
      var box = el('div', 'gf-page__textbox');
      box.appendChild(el('p', null, p.text));
      wrap.appendChild(box);
      page.appendChild(wrap);
    }
    page.appendChild(el('p', 'gf-page__num', String(p.page)));
    return page;
  }

  function render() {
    var stage = reader.querySelector('[data-stage]');
    var v = views[index];
    stage.innerHTML = '';

    if (v.type === 'title') {
      // Intro, not just a title card. This is the page that proves the book was
      // built from what a parent actually wrote — the answers on the left, and
      // the real photo turning into the character on the right.
      var intro = el('div', 'gf-intro');

      // No big title here — the book title is already in the reader's own header,
      // and the space is better spent on cast for books with more characters.
      var head = el('div', 'gf-intro__head');
      head.appendChild(el('div', 'gf-intro__for', 'Made for ' + book.child +
        (book.age ? ', age ' + book.age : '')));
      intro.appendChild(head);

      var body = el('div', 'gf-intro__body');

      var brief = el('div', 'gf-intro__brief');
      brief.appendChild(el('div', 'gf-intro__label', 'What ' + book.child + '’s parent told us'));
      if (book.interest) {
        var qi = el('div', 'gf-intro__qa');
        qi.appendChild(el('div', 'gf-intro__q', 'What do they love right now?'));
        qi.appendChild(el('div', 'gf-intro__a', book.interest));
        brief.appendChild(qi);
      }
      if (book.struggle) {
        var qs = el('div', 'gf-intro__qa');
        qs.appendChild(el('div', 'gf-intro__q', 'What should this story help with?'));
        qs.appendChild(el('div', 'gf-intro__a', book.struggle));
        brief.appendChild(qs);
      }
      body.appendChild(brief);

      var urls = (window.__gfCastUrls || {})[book.id];
      if (urls && urls.photo && urls.char) {
        var cast = el('div', 'gf-intro__cast');
        cast.appendChild(el('div', 'gf-intro__label', 'Their photo, and the character we drew'));
        var pair = el('div', 'gf-intro__pair');
        var f1 = el('figure', 'gf-intro__shot');
        var i1 = document.createElement('img');
        i1.src = urls.photo; i1.alt = 'The photo ' + book.child + '’s parent uploaded';
        i1.loading = 'lazy'; i1.decoding = 'async';
        f1.appendChild(i1);
        pair.appendChild(f1);
        pair.appendChild(el('div', 'gf-intro__arrow', '→'));
        var f2 = el('figure', 'gf-intro__shot gf-intro__shot--char');
        var i2 = document.createElement('img');
        i2.src = urls.char; i2.alt = book.child + ' as they appear in the book';
        i2.loading = 'lazy'; i2.decoding = 'async';
        f2.appendChild(i2);
        pair.appendChild(f2);
        cast.appendChild(pair);
        body.appendChild(cast);
      }

      intro.appendChild(body);
      stage.appendChild(intro);
    } else if (v.type === 'end') {
      var end = el('div', 'gf-reader__end');
      end.appendChild(el('div', 'gf-reader__end-title', 'The End'));
      end.appendChild(el('p', 'gf-reader__end-sub',
        book.child + '’s book was written around one real child. Yours would be written around yours.'));
      var a = el('a', 'gf-btn gf-btn--primary', book.ctaLabel || 'Create their story');
      a.href = book.ctaHref || '#';
      end.appendChild(a);
      stage.appendChild(end);
    } else {
      var op = el('div', 'gf-opening' + (v.pages.length === 1 ? ' gf-opening--solo' : ''));
      v.pages.forEach(function (p) { op.appendChild(buildPage(p)); });
      stage.appendChild(op);

      // Readable repeat of the same words — CSS shows this on phones only, where
      // the print-exact caption on the page itself is too small to read.
      var words = v.pages.map(function (p) { return p.text; }).filter(Boolean).join('\n\n');
      if (words) stage.appendChild(el('p', 'gf-reader__cap', words));
    }

    var label = v.type === 'pages'
      ? (v.pages.length === 2 ? v.pages[0].page + '–' + v.pages[1].page : String(v.pages[0].page))
      : (v.type === 'title' ? 'Title' : 'End');
    reader.querySelector('[data-count]').textContent = label;
    reader.querySelector('[data-prev]').disabled = index === 0;
    reader.querySelector('[data-next]').disabled = index === views.length - 1;
    reader.querySelector('[data-progress]').style.width = ((index + 1) / views.length * 100) + '%';
    stage.scrollTop = 0;
    preload(index + 1);
    preload(index + 2);
  }

  function preload(i) {
    var v = views[i];
    if (!v || v.type !== 'pages') return;
    v.pages.forEach(function (p) { var im = new Image(); im.src = p.src; });
  }

  function go(i) {
    if (i < 0 || i >= views.length || i === index) return;
    index = i;
    render();
  }

  function open(b, trigger) {
    ensureLora();
    build();
    book = b;
    views = makeViews(b);
    index = 0;
    opener = trigger || null;

    reader.querySelector('[data-title]').textContent = b.title;
    reader.querySelector('[data-brief]').textContent = b.struggle ? '“' + b.struggle + '”' : '';
    var cta = reader.querySelector('[data-cta]');
    cta.href = b.ctaHref || '#';
    cta.textContent = b.ctaLabel || 'Create their story';

    reader.hidden = false;
    document.body.classList.add('gf-reader-open');
    requestAnimationFrame(function () { reader.classList.add('is-open'); });
    render();
    reader.querySelector('[data-close]').focus();
  }

  function close() {
    if (!reader) return;
    reader.classList.remove('is-open');
    document.body.classList.remove('gf-reader-open');
    window.setTimeout(function () {
      reader.hidden = true;
      reader.querySelector('[data-stage]').innerHTML = '';
    }, 300);
    if (opener) opener.focus();
  }

  var library = null;
  function getLibrary() {
    if (library) return library;
    library = {};
    var node = document.getElementById('gf-samples-data');
    if (!node) return library;
    try {
      JSON.parse(node.textContent).forEach(function (b) { library[b.id] = b; });
    } catch (err) { /* malformed manifest — cards simply stay inert */ }
    // Asset URLs come from a sibling block because Liquid has to resolve them.
    // Missing or malformed simply means the intro renders without the pair.
    var castNode = document.getElementById('gf-cast-urls');
    if (castNode) {
      try { window.__gfCastUrls = JSON.parse(castNode.textContent); } catch (e) { window.__gfCastUrls = {}; }
    }
    return library;
  }

  function initSamples() {
    document.querySelectorAll('[data-gf-sample]:not([data-gf-bound])').forEach(function (btn) {
      btn.setAttribute('data-gf-bound', '');
      btn.addEventListener('click', function () {
        var b = getLibrary()[btn.getAttribute('data-gf-sample')];
        if (!b) return;
        // CTA is a section setting, not book data — merge it in at open time.
        var host = btn.closest('[data-gf-samples]');
        if (host) {
          b = Object.assign({}, b, {
            ctaHref: host.getAttribute('data-cta-href') || '#',
            ctaLabel: host.getAttribute('data-cta-label') || 'Create their story',
          });
        }
        open(b, btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSamples);
  } else {
    initSamples();
  }
  document.addEventListener('shopify:section:load', initSamples);

  window.GFReader = { open: open, close: close };
})();
